import {Button, Drawer, DrawerProps, Table} from 'antd';
import Style from './index.module.scss';
import type {ColumnsType} from 'antd/es/table';
import {useMutation, useQuery} from 'react-query';
import {AgentMcp} from '../../../agentMcpService';
import useSelection from 'Utils/Hooks/useSelection';
import React from 'react';

interface Props extends DrawerProps {
    agentId: string;
    onOk: () => void;
}

const Index = ({agentId, onOk, ...props}: Props) => {
    const rowSelection = useSelection<AgentMcp.List>();

    const getData = useQuery({
        queryKey: ['McpFunction.options', agentId],
        queryFn: () => AgentMcp.options({agentId}),
    });

    const onSave = useMutation({
        mutationFn: AgentMcp.save,
        onSuccess: () => {
            onOk();
        },
    });

    const columns: ColumnsType<AgentMcp.List> = [
        {
            title: 'Mcp名称',
            dataIndex: 'name',
        },
        {
            title: 'Mcp Code',
            dataIndex: 'code',
        },
        {
            title: 'baseUrl',
            dataIndex: 'baseUrl',
        },
    ];

    function onFinish() {
        onSave.mutate({
            agentId,
            data: rowSelection.selectedRows.map(item => {
                const {createdAt, updatedAt, ...rest} = item;
                rest.priority = 0;
                rest.enabled = true;
                return rest;
            }),
        });
    }

    function Extra() {
        return (
            <Button type="primary" onClick={onFinish}>
                保存
            </Button>
        );
    }

    return (
        <Drawer
            title="选择Mcp"
            width="800"
            className={Style.root}
            extra={<Extra />}
            {...props}>
            <Table
                rowKey="id"
                bordered
                size="small"
                columns={columns}
                dataSource={getData.data}
                loading={getData.isLoading || onSave.isLoading}
                scroll={{x: 'max-content'}}
                pagination={false}
                rowSelection={rowSelection}
            />
        </Drawer>
    );
};

export default Index;
